import { BadgedLink, IconArrowLeftSmallOutline, TextSmall } from '@teamleader/ahoy';
import { translate } from '@teamleader/i18n';
import React from 'react';

interface BackToLoginLinkProps {
  onClick: () => void;
  className?: string;
}

const BackToLoginLink = ({ onClick, className }: BackToLoginLinkProps) => (
  <BadgedLink className={className} onClick={onClick} inherit={false} icon={<IconArrowLeftSmallOutline />}>
    <TextSmall>{translate('mfa.goBackToLogin')}</TextSmall>
  </BadgedLink>
);

export default BackToLoginLink;
